import React, { createContext, useContext, useState } from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';

var ConfirmAlertContext = createContext({});
var useConfirmAlert = function () {
    var confirm = useContext(ConfirmAlertContext).confirm;
    return confirm;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var ConfirmationDialog = function (_a) {
    var open = _a.open, _b = _a.options, title = _b.title, description = _b.description, okButtonText = _b.okButtonText, cancelButtonText = _b.cancelButtonText, onClose = _a.onClose, props = __rest(_a, ["open", "options", "onClose"]);
    var handleCancel = function () {
        onClose(false);
    };
    var handleOk = function () {
        onClose(true);
    };
    return (React.createElement(Dialog, __assign({ id: "confirmation-dialog", fullWidth: true, open: open }, props),
        React.createElement(DialogTitle, { id: "confirmation-dialog-title" }, title),
        description && (React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { id: "confirmation-dialog-description" }, description))),
        React.createElement(DialogActions, { id: "confirmation-dialog-actions" },
            React.createElement(Button, { autoFocus: true, onClick: handleCancel, variant: "outlined", color: "secondary" }, cancelButtonText),
            React.createElement(Button, { onClick: handleOk, variant: "contained", color: "primary" }, okButtonText))));
};

var defaultOptions = {
    okButtonText: 'Ok',
    cancelButtonText: 'Cancel',
    title: 'Are you sure?',
    description: '',
};
var ConfirmAlertProvider = function (props) {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState(defaultOptions), options = _b[0], setOptions = _b[1];
    var _c = useState([]), promiseObject = _c[0], setPromiseObject = _c[1];
    var confirm = function (options) {
        if (options === void 0) { options = defaultOptions; }
        try {
            if (typeof options !== 'object' && typeof options !== 'string') {
                throw new Error("options should be either 'string' or 'object' in useConfirmAlert 'confirm' function");
            }
            if (typeof options === 'string') {
                options = { title: options || defaultOptions.title };
            }
            var confirmOptions = __assign(__assign({}, defaultOptions), options);
            setOptions(confirmOptions);
            return new Promise(function (resolve, reject) {
                setOpen(true);
                setPromiseObject([resolve, reject]);
            });
        }
        catch (e) {
            console.error(e);
        }
    };
    var onClose = function (result, promiseObject) {
        var resolve = promiseObject[0];
        setOpen(false);
        if (result) {
            resolve(true);
        }
        else {
            resolve(false);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfirmAlertContext.Provider, { value: { confirm: confirm } }, props.children),
        React.createElement(ConfirmationDialog, { open: open, onClose: function (result) { return onClose(result, promiseObject); }, options: options })));
};

export { ConfirmAlertProvider, useConfirmAlert };
